import { useState } from 'react';

import { Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useBoolean } from 'usehooks-ts';

import { useUserInfo } from '@/features/users';

import { useSubscriptions } from '../hooks';

import { Section } from './layout/Section';
import { SubscriptionsDrawer } from './drawer';
import { ProductTabs } from './ProductTabs';
import { UnsubscribeDialog } from './UnsubscribeDialog';

export const Subscriptions = () => {
  const { company_id } = useUserInfo();
  const { data, isFetching } = useSubscriptions(company_id);

  const { value: isCollapsed, toggle: toggleIsCollapsed } = useBoolean(true);
  const { value: isDrawerVisible, toggle: toggleIsDrawerVisible } =
    useBoolean();
  const {
    value: isConfirmationDialogVisible,
    toggle: toggleConfirmationDialog,
  } = useBoolean();

  const [activeTab, setActiveTab] = useState<number>(0);
  const [unsubscribePID, setUnsubscribePID] = useState<number>(0);

  return (
    <Section
      title={'Subscriptions'}
      isCollapsed={isCollapsed}
      toggleIsCollapsed={toggleIsCollapsed}
    >
      <Typography fontSize={13} pr={6} mt={0.5} pb={3.5}>
        Please Note: These subscriptions are offered in line with our full{' '}
        <Link component={RouterLink} to="https://changegps.com.au/legal">
          Terms & Conditions
        </Link>
        . To downgrade your account, requests must be submitted through the
        platform no less than 30 days before the end of your Plan&apos;s current
        Annual Cycle.
      </Typography>
      <Stack direction={'row'} spacing={4} flexWrap={'wrap'} useFlexGap>
        <ProductTabs
          data={data}
          loading={isFetching}
          toggleDrawer={toggleIsDrawerVisible}
          toggleConfirmationDialog={toggleConfirmationDialog}
          setActiveTab={setActiveTab}
          onSelectUnsubscribe={setUnsubscribePID}
        />
      </Stack>
      <UnsubscribeDialog
        companyID={company_id}
        productID={unsubscribePID}
        isVisible={isConfirmationDialogVisible}
        toggleIsVisible={toggleConfirmationDialog}
      />
      <SubscriptionsDrawer
        isVisible={isDrawerVisible}
        toggleIsVisible={toggleIsDrawerVisible}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
    </Section>
  );
};
